import { ArrowLeft, Construction } from "lucide-react";

interface PlaceholderPaneProps {
  label: string;
  onBack: () => void;
}

export function PlaceholderPane({ label, onBack }: PlaceholderPaneProps) {
  return (
    <div className="flex flex-col gap-0 h-full rounded-lg border bg-card overflow-hidden" style={{ boxShadow: "var(--shadow-card)" }}>
      <div className="flex items-center gap-2 border-b px-3 py-2.5 bg-muted/20">
        <button
          onClick={onBack}
          className="flex items-center gap-1 text-[11px] font-semibold text-muted-foreground hover:text-foreground transition-colors"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Back to My Loads
        </button>
        <span className="text-[10px] text-muted-foreground">|</span>
        <h4 className="text-caption font-bold text-foreground">{label}</h4>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center gap-3 p-8 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-muted/60">
          <Construction className="h-6 w-6 text-muted-foreground" />
        </div>
        <div>
          <p className="text-sm font-semibold text-foreground">{label}</p>
          <p className="text-[12px] text-muted-foreground mt-1">This feature is coming soon. Stay tuned.</p>
        </div>
      </div>
    </div>
  );
}
